import { ExternalLink } from "lucide-react";
import { useLang } from "../store";
import { PageHead, Reveal } from "../components/Reveal";
import Footer from "../components/Footer";
import Marquee from "../components/Marquee";
import { BIO_IT, BIO_EN, PRESS_LINKS } from "../data/bio";

const PORTRAIT = "/media/davide-portrait.webp";

export default function About() {
  const { lang, t } = useLang();
  const bio = lang === "it" ? BIO_IT : BIO_EN;

  return (
    <div className="min-h-screen" data-testid="about-page">
      <PageHead kicker="BIO · PRESS" title={t("about.title")} sub={t("about.sub")} />

      <div className="mx-auto max-w-[1600px] px-6">
        <div className="grid gap-12 pb-20 lg:grid-cols-[420px_1fr]">
          <Reveal>
            <div className="poster-frame overflow-hidden rounded border border-white/10">
              <img src={PORTRAIT} alt="Davide Campagna" className="w-full object-cover" data-testid="about-portrait" />
            </div>
            <div className="font-mono2 mt-5 space-y-1.5 text-[11px] tracking-widest text-slate-500" data-testid="about-facts">
              {t("about.facts").map((f) => <p key={f}>{f}</p>)}
            </div>
          </Reveal>
          <div className="space-y-6" data-testid="about-bio">
            {bio.map((p, i) => (
              <Reveal key={i} delay={Math.min(i, 3) * 0.08}>
                {i === 0 ? (
                  <p className="font-serif-it text-xl italic leading-relaxed text-slate-300 sm:text-2xl">{p}</p>
                ) : (
                  <p className="text-base leading-relaxed text-slate-400">{p}</p>
                )}
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal>
          <h2 className="font-display text-2xl uppercase tracking-tight sm:text-3xl">{t("about.press")}</h2>
          <p className="mt-2 text-sm text-slate-500">{t("about.pressSub")}</p>
        </Reveal>
        <div className="mt-8 grid gap-4 pb-24 md:grid-cols-2 lg:grid-cols-3" data-testid="press-board">
          {PRESS_LINKS.map((p, i) => (
            <Reveal key={p.url} delay={(i % 3) * 0.08}>
              <a
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`press-link-${i}`}
                className="dc-card group flex h-full flex-col justify-between rounded p-6 transition-colors hover:border-amber-500/50"
              >
                <div>
                  <p className="font-mono2 text-[10px] tracking-[0.3em] text-amber-500">{p.source.toUpperCase()}</p>
                  <p className="font-serif-it mt-3 text-lg italic leading-relaxed text-slate-300">{p.title}</p>
                </div>
                <span className="font-mono2 mt-5 inline-flex items-center gap-2 text-[11px] tracking-widest text-slate-500 transition-colors group-hover:text-amber-400">
                  {t("about.readArticle")} <ExternalLink size={13} />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
      <Marquee />
      <Footer />
    </div>
  );
}
